<template>
  <div class="centers">
    <div class="center_head pl16">
      <img src="../../assets/images/new/head_logo.png" alt="">
      <div class="close pr24" @click="quit">
        <i class="icon el-icon-switch-button"></i>
        <p>退出登录</p>
      </div>
    </div>
    <div class="main">
      <div class="shops">
        <div class="title">选择门店</div>
        <div class="boxs">
          <div class="box" v-for="(item,index) in list" :key="index" @click="selectShop(item)">
            <div class="flex-row">
              <el-image v-if="item.imgUrl" class="img" :src="item.imgUrl"></el-image>
              <el-image v-else class="img" :src="shopImg"></el-image>
              <div class="msg">
                <span class="name">{{ item.shopName }}</span>
                <p class="address">{{ item.address }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { menuInfoSet } from '../../assets/javascript/menu';
export default {
  components: {},
  data() {
    return {
      appInfo: this.$store.getters.AppInfo,
      shopImg: require("../../assets/images/new/shop_defalt.png"),
      list: [],
	  items:[],
      menuInfo: []
    };
  },
  created() {
    this.init();
  },
  methods: {
    selectShop(item) {
      this.$api.post(this.$url.shop.switchShop, {
        platformType: "merchantweb",
        registrationId: "",
        shopId: item.id
      }).then(res => {
        if (res) {
          localStorage.setItem("shopIds",res.shopId)
          localStorage.setItem("mainMenuList",JSON.stringify(res.mainMenuList))
          this.initDataMenu().then(result => {
            this.getMenus();
          });
          this.$store.commit("setShopMessage", res);
          this.getStaffPermCodeFunc()
        }
      });
    },
    async getStaffPermCodeFunc () {
      let res = await this.$api.get(this.$url.common.getStaffPermCode)
      if (res) {
        console.log(res, 'permDir');
        localStorage.setItem('permissions', JSON.stringify(res.permMap))
      }
    },
    getMenus() {
	 
      this.$api.post(this.$url.common.allMenuList, {
        queryFrom: "pc"
      }).then(res => {
        if (res) {
          this.menuInfo = res;
          this.setMenu();
		  this.getMainMenu();
          this.$store.commit("setShowMenus", res);
        }
      })
    },
	 getMainMenu(){
		let url = "/collectMoney"
		let setCurentPage = "cashier"
		 this.items = JSON.parse(localStorage.getItem("mainMenuList"));
		if (this.items!=null&&this.items.length>0) {
			let code = this.items[0].code;
			if (code == "collectMoney") {
				url="/collectMoney"
				setCurentPage="cashier"
			}else if (code == "shop") {
				url="/manage"
				setCurentPage="shop"
			}else if (code == "member") {
				url="/member"
				setCurentPage=""
			}else if (code == "order") {
				url="/orderInfo"
				setCurentPage=""
			}else if (code == "workPlateForm") {
				url="/dataList"
				setCurentPage="data"
			}
		}else{
			this.$message.error("请先联系相关人员分配门店角色");
			return false;
		}
		this.$store.commit("setCurentPage", setCurentPage);
		this.$router.push(url);
	},
    init() {
      this.list = this.appInfo.shopList;
    },
    quit() {
      this.$api.post(this.$url.logout, {}).then(res => {
        if (res) {
          this.$store.commit("setLoginUser", null);
          this.$router.push("/ssoLogin");
        }
      });
    },
    setMenu () {
      if (this.menuInfo) {
        menuInfoSet(this.menuInfo, 'cashierAndShop')
      }
    },
    async initDataMenu() {
      this.$api.post(this.$url.common.dataMenuList, {
        queryFrom: "pc"
      }).then(res => {
        if (res) {
          this.menuInfo = res;
          localStorage.setItem("dataList", JSON.stringify(res))
          this.setDataMenu();
        }
      });
    },
    setDataMenu() {
      if (this.menuInfo) {
        menuInfoSet(this.menuInfo)
      }
	  }
  }
};
</script>

<style lang="less" scoped>
.centers {
  font-size: 0.16rem;
  height: 100%;
  .center_head {
    height: 58px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #111;
  }
  .close {
	color: #fff;
	display: flex;
	align-items: center;
	font-size: 1rem;
	.icon {
	  font-size: 0.8rem;
	  margin-right: 0.3rem;
	  vertical-align: middle;
	}
	&:hover {
	  cursor: pointer;
	}
  }
  .head {
    display: flex;
    padding: 0 30px;
    align-items: center;
    justify-content: space-between;
    height: 70px;
    background: #2e334f;
    .logo-img {
      width: 144px;
      height: 47px;
    }
  }
  .main {
    padding: 16px;
    height: calc(100% - 70px);
    background: #eeeeee;
    box-sizing: border-box;
    .shops {
      height: 100%;
      background: #fff;
      box-shadow: 0px 0px 14px 0px rgba(6, 0, 1, 0.1);
      border-radius: 4px;
      /deep/ .title {
        height: 60px;
        font-size: 20px;
        line-height: 60px;
      }
      .boxs {
        padding: 16px;
        display: flex;
        flex-wrap: wrap;
        max-height: calc(100% - 60px);
        overflow: auto;
        box-sizing: border-box;
        .box {
          width: calc((96%  / 5) - 42px);
          height: 90px;
          padding: 20px;
          margin-right: 1%;
          margin-bottom: 20px;
          border: 1px solid #E5E5E5;
          border-radius: 4px;
          cursor: pointer;
          &:nth-of-type(5n) {
            margin-right: 0;
          }
           &:hover {
              background: #d4eaff;
            }
          .img {
            width: 90px;
            height: 90px;
            border-radius: 4px;
          }
          .msg {
            margin-left: 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            flex: 2;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .name {
              font-size: 18px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box; //将对象作为弹性伸缩盒子模型显示。
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
            }
            .address {
              font-size: 12px;
              color: #666;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box; //将对象作为弹性伸缩盒子模型显示。
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
            }
          }
        }
      }
    }
  }
}
</style>